<div>
    <div class="">
        <ul class="list-none p-0 m-0 card">
            <li *ngFor="let item of cartItems$ | async" class="cart-item p-3 border-bottom-1 surface-border">

                <!-- Linha 1: imagem + nome -->
                <div class="top-row">
                    <img [src]="item.image" alt="Imagem do Produto" class="thumb" />

                    <div class="title-area">
                        <div class="item-title text-base text-left">
                            {{ item.name }}
                        </div>

                        <div *ngIf="item.variant" class="item-variant text-sm opacity-70 mt-1 text-left">
                            {{ item.variant }}
                        </div>
                    </div>
                </div>

                <!-- Linha 2: quantidade + preço + lixeira -->
                <div class="bottom-row">

                    <!-- qty -->
                    <div class="qty-wrapper">
                        <button pButton type="button" class="qty-btn p-button-text" (click)="stepQuantity(item, -1)">
                            <i class="pi pi-minus"></i>
                        </button>
                        <p-inputNumber class="qty-input" [(ngModel)]="item.quantity" [showButtons]="false"
                            (ngModelChange)="onQuantityChange(item, $event)"
                            (keydown)="preventManualInput($event)"
                            [min]="item.tracked && (item.stock ?? item.inventory_quantity ?? 0) <= 0 ? 0 : 1">
                        </p-inputNumber>
                        <button pButton type="button" class="qty-btn p-button-text" (click)="stepQuantity(item, 1)">
                            <i class="pi pi-plus"></i>
                        </button>
                    </div>


                    <div class="right-actions">
                        <!-- price -->
                        <div class="item-price">
                            R${{ (item.price * item.quantity) | number: '1.2-2' }}
                        </div>

                        <!-- delete -->
                        <a (click)="removeItem(item)" class="item-delete text-pink-500 hover:text-pink-600 cursor-pointer">
                            <i class="pi pi-trash"></i>
                        </a>
                    </div>

                </div>

                <!-- Mensagem de erro -->
                <small *ngIf="cartErrors[getItemKey(item)]" class="p-error mt-1 block text-left">
                    {{ cartErrors[getItemKey(item)] }}
                </small>

            </li>

        </ul>


    </div>
</div>
